export function SuggestionButton({ value, onApply, testId }) {
  return (
    <button type="button" onClick={() => onApply(value)} data-testid={testId} className="mt-1 inline-flex min-h-[44px] items-center text-left text-xs text-foreground underline decoration-gold/60 underline-offset-4 hover:decoration-gold sm:min-h-0">
      Use {value}
    </button>
  );
}
